import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserStatus} from "../../constants/Conferences";
import {RootState} from "../../store";

export interface callState {
    status: UserStatus;
    callData: any;
    incomingData: any;
    canceledData: any;
    rejectedData: any;
}

const initialState: callState = {
    status: UserStatus.AVAILABLE,
    callData: null,
    incomingData: null,
    canceledData: null,
    rejectedData: null,
}

export const callSlice = createSlice({
    name: 'call',
    initialState,
    reducers: {
        incomingCallEvent: (state, action: PayloadAction<any>) => {
            state.status = UserStatus.AVAILABLE;
            state.incomingData = action.payload;
        },
        canceledCallEvent: (state, action: PayloadAction<any>) => {
            state.status = UserStatus.AVAILABLE;
            state.canceledData = action.payload;
        },
        rejectedCallEvent: (state, action: PayloadAction<any>) => {
            state.status = UserStatus.AVAILABLE;
            state.rejectedData = action.payload;
        },
        pickUp: (state) => {
            state.status = UserStatus.BUSY;
            state.callData = state.incomingData;
            state.incomingData = null;
        },
        hangUp: (state) => {
            if (state.status === UserStatus.BUSY) {
                state.status = UserStatus.AVAILABLE;
                state.callData = null;
            }
        },
        reject: (state) => {
            state.incomingData = null;
        }
    }
})

export const { incomingCallEvent, canceledCallEvent, rejectedCallEvent, pickUp, hangUp, reject } = callSlice.actions

export const call = (state: RootState) => state.call

export default callSlice.reducer